<template>
  <b-row>
    <b-col cols="12" lg="6">
      <b-card>
        <div slot="header">
          <strong>{{ number.number }}</strong> <b-badge class="ml-1" style="position: relative; top: -1px;">{{ number.provider.name }}</b-badge>
          <number-status class="pull-right mt-1" style="position: relative; top: -1px;" :status="number.status" :focDate="number.focDate"></number-status>
        </div>
        <b-row>
          <b-col cols="6">
            <b-form-group>
              <label for="name">Name</label>
              <b-form-input type="text" id="name" placeholder="Enter Name" v-model="number.name"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Account">
              <b-select :options="accountOptions" v-model="number.accountId"></b-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="8">
            <b-form-group>
              <label for="callerid">Caller ID</label>
              <b-form-input type="text" id="callerid" placeholder="Enter Caller ID" v-model="number.callerid"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-show="number.accountId && number.provider.voice">
          <b-col cols="4">
            <b-form-group label="e911 Location">
              <b-select :options="locationOptions" v-model="number.locationId"></b-select>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label for="ring">Distinctive Ring</label>
              <b-select id="ring" :options="ringOptions" v-model="number.ring"></b-select>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label for="ring">Spam Block</label>
              <b-select id="ring" :options="spamOptions" v-model="number.spamBlock"></b-select>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="footer">
          <b-btn size="sm" variant="primary" @click="save">Save</b-btn>
        </div>
      </b-card>
    </b-col>
    <!-- <b-col cols="12" lg="6" v-show="number.accountId && number.provider.voice">
      <b-card border-variant="primary" header-bg-variant="primary" header-text-variant="white" header="Inbound Routing">
        <inbound-routes :numberId="number.id" v-model="inboundRoutes" @routeUpdate="routeUpdate" @sortUpdate="sortUpdate"></inbound-routes>
      </b-card>
    </b-col> -->
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import InboundRoutes from './partials/InboundRoutes.vue'
import NumberStatus from '@/components/badges/NumberStatus'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

export default {
  name: 'Number',
  props: {
    caption: {
      type: String,
      default: 'Number id'
    },
  },
  computed: {
    ...mapGetters({
      account: 'global/account',
    }),
    accountOptions () {
      return [
        { value: null, text: 'Un-Assigned' }
      ].concat(this.accounts.map((o) => {
        return { value: o.id, text: o.name }
      }).sort((a, b) => {
        if (a.text > b.text) return 1
        else if (a.text < b.text) return -1
        return 0
      }))
    },
    locationOptions () {
      return [
        { value: null, text: 'Disabled' }
      ].concat(this.locations.filter((o) => o.e911).map((o) => {
        return { value: o.id, text: o.name }
      }))
    },
  },
  components: {
    InboundRoutes,
    NumberStatus,
    VueCtkDateTimePicker
  },
  data: () => {
    return {
      number: {
        provider: {
          fax: false,
          voice: false
        }
      },
      inboundRoutes: [],
      accounts: [],
      locations: [],
      ringOptions: [
        { value: null, text: 'Default' },
        { value: 2, text: 'Secondary' }
      ],
      spamOptions: [
        { value: false, text: 'Off' },
        { value: true, text: 'On' }
      ],
    }
  },
  methods: {
    routeUpdate (type, index, data) {
      if (type === 'save') {
        if (index >= 0) {
          this.$set(this.inboundRoutes, index, data)
        }
      } else if (type === 'delete') {
        this.inboundRoutes.splice(index, 1)
      }
    },
    sortUpdate (routes) {
      this.inboundRoutes = routes
    },
    async save() {
      const id = this.$route.params.id
      const { data }  = await this.$axios.put(`/v1/numbers/${id}`, this.number)
      this.number = data
      this.$store.dispatch('global/getNumbers')
    },
    goBack() {
      this.$router.go(-1)
    },
    async getNumber(id) {
      const { data } = await this.$axios.get(`/v1/numbers/${id}`)
      this.number = data
    },
    async getRoutes(id) {
      const { data } = await this.$axios.get(`/v1/numbers/routes?numberId=${id}`)
      this.inboundRoutes = data
    },
    async getLocations() {
      if (!this.number.accountId) return []
      const { data } = await this.$axios.get(`/v1/locations?accountId=${this.number.accountId}`)
      this.locations = data
    },
    async getAccounts () {
      const { data } = await this.$axios.get(`/v1/accounts`)
      this.accounts = data
    },
  },
  watch: {
    'number.accountId': {
      handler () {
        this.getLocations()
      }
    }
  },
  created () {
    this.getNumber(this.$route.params.id)
    this.getRoutes(this.$route.params.id)
    this.getLocations()
    this.getAccounts()
  }
}
</script>
